export const FORM_IDS = {
  PREFERENCES: {
    URI_RADIO_GROUP: 'Preferences__URI__Radio__Group',
  },
};
